module.exports = __webpack_public_path__ + "img/trtKit.3b0fa7b3.svg";